import { SET_WS_TOKEN, QUIZ_SUBMISSION_EVENT } from '@instructure/quiz-common';
import { featureOn } from '../../common/util/featureCheck';
import { formatTime } from '../../common/util/formatTimespan';
import { updateTime, notifyTimeAdded } from '../../taking/api/taking';
import { bindActionCreators } from 'redux';
var takingApiActions = {
  updateTime: updateTime,
  notifyTimeAdded: notifyTimeAdded
};
export var createWebsocket = function createWebsocket(url, token) {
  return new WebSocket("".concat(url, "?token=").concat(token));
};
export var handleExtraTime = function handleExtraTime(extraTimeInSeconds, endAt, updateTimeAction, notifyTimeAdded) {
  var remainingTimeInMs = new Date(endAt) - Date.now();
  var remainingTimeInSeconds = Math.floor(remainingTimeInMs / 1000);
  var formattedExtraTimeText = formatTime(extraTimeInSeconds);
  var isUnlimited = endAt === null && extraTimeInSeconds === null;
  updateTimeAction(remainingTimeInSeconds, !isUnlimited);
  notifyTimeAdded(!isUnlimited, !isUnlimited ? formattedExtraTimeText : null);
};
export var parseJwt = function parseJwt(token) {
  try {
    return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
  } catch (_unused) {
    return null;
  }
};
export var initializeWebSocket = function initializeWebSocket(token, createWebsocketFn) {
  var jwt = parseJwt(token);
  if (!jwt) {
    return null;
  }
  return createWebsocketFn(jwt['aud'], token);
};
export var handleWebSocketMessage = function handleWebSocketMessage(webSocketMessage, boundTakingApiActions, handleExtraTimeFn) {
  var _webSocketMessageData, _webSocketMessageData2;
  var webSocketMessageData = JSON.parse(webSocketMessage.data);
  webSocketMessageData = ((_webSocketMessageData = webSocketMessageData) === null || _webSocketMessageData === void 0 || (_webSocketMessageData = _webSocketMessageData.message) === null || _webSocketMessageData === void 0 ? void 0 : _webSocketMessageData.data) || ((_webSocketMessageData2 = webSocketMessageData) === null || _webSocketMessageData2 === void 0 ? void 0 : _webSocketMessageData2.data);
  if (!webSocketMessageData) {
    return;
  }
  var type = webSocketMessageData.type;
  if (type !== 'accommodation_changed') {
    return;
  }
  handleExtraTimeFn(webSocketMessageData.extra_time_in_seconds, webSocketMessageData.end_at, boundTakingApiActions.updateTime, boundTakingApiActions.notifyTimeAdded);
};
export var createQuizTimerWebSocketMiddleware = function createQuizTimerWebSocketMiddleware() {
  var createWebsocketFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : createWebsocket;
  var featureOnFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : featureOn;
  var socket = null;
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === SET_WS_TOKEN && featureOnFn('add_time_to_existing_quiz_sessions') && socket === null) {
          var token = action.payload.wsToken;
          socket = initializeWebSocket(token, createWebsocketFn);
          if (!socket) {
            return next(action);
          }
          var boundTakingApiActions = bindActionCreators(takingApiActions, store.dispatch);
          socket.addEventListener('message', function (webSocketMessage) {
            handleWebSocketMessage(webSocketMessage, boundTakingApiActions, handleExtraTime);
          });
        }
        if (action.type === QUIZ_SUBMISSION_EVENT && socket !== null) {
          socket.close();
          socket = null;
        }
        return next(action);
      };
    };
  };
};